<script>
import { isEqual, get, sortBy } from 'lodash/fp'

import Toggleable from '@/mixins/toggleable'

export default {
  name: 'FilterSelect',
  mixins: [Toggleable],
  props: {
    filter: {
      type: Object,
      required: true
    },
    filterIndex: Number,
    value: [Object, String, Number]
  },
  data () {
    return {
      expanded: false,
      loading: false,
      maxItemsToShow: 10
    }
  },
  computed: {
    sortedItems () {
      console.log('FilterSelect sortedItems')
      console.log('this: ', this)
      console.log('this.filter: ', this.filter)
      console.log('this.filter.items: ', this.filter.items)
      return this.filter.itemText
        ? sortBy(item => get(this.filter.itemText, item), this.filter.items)
        : sortBy(item => item, this.filter.items)
    }
  },
  methods: {
    selectChanged (e) {
      console.log('e: ', e)

      const currentValue = this.value
      console.log('currentValue', currentValue)

      // If the currentvalue is chosen, emit 'null' instead to 'deselect' it
      this.$emit('update', isEqual(currentValue, e) ? null : e)
    }
  },
  render (h) {
    const select = <v-select
      items={this.sortedItems}
      value={this.value}
      onChange={this.selectChanged}
      placeholder={this.filter.label}
      returnObject={this.filter.returnObject}
      itemValue={this.filter.itemValue}
      itemText={this.filter.itemText}
      hideDetails
      clearable
      dense
      class='input--dense'
    />

    return (
      <v-list-group
        value={this.expanded}
      >
        <v-list-tile slot="activator">
          <v-list-tile-content>
            <v-list-tile-title>{this.filter.label}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile>
          {select}
        </v-list-tile>
      </v-list-group>
    )
  }
}
</script>

<style lang="stylus" scoped>
.filter-list
  .filter-list__header
    display: flex
    align-items: center
    user-select: none
    cursor: pointer
    padding:8px 12px

  .filter-list__header:hover
      background-color: rgba(88, 88, 88, .33)

</style>
